"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemberLink = exports.getCredentialImageFromUrl = void 0;
const axiosConfig_1 = require("../axios/axiosConfig");
const constants_1 = require("../../constants/constants");
const getCredentialImageFromUrl = (url) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.Routes.getCredentialImageFromUrl(), {
            credential_url: url,
        }, { responseType: "blob", withCredentials: false });
        // image will be piped to the response  return it
        return response.data;
    }
    catch (error) {
        console.log(error);
        throw error;
    }
});
exports.getCredentialImageFromUrl = getCredentialImageFromUrl;
const getMemberLink = (certificateNo) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.Routes.getMemberLink(), {
            certificateNo: certificateNo,
        });
        return response.data.data;
    }
    catch (error) {
        console.log(error);
        throw error;
    }
});
exports.getMemberLink = getMemberLink;
